export const types = {
  appointment: 'Agenda',
  medical_record: 'Prontuário',
};

export function getName(value) {
  return types[value];
}
